import { c as _c } from "react/compiler-runtime";
import React from "react";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { faTrophy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
interface WinnerDropBadgeProps {
  rank: number | null;
  round?: number;
  position?: number; // Position within the same rank (e.g., 2nd #1 place winner)
  decisionTime: number | null; // Add decision time parameter
}
const WinnerDropBadge: React.FC<WinnerDropBadgeProps> = t0 => {
  const $ = _c(22);
  const {
    rank,
    round: t1,
    position: t2,
    decisionTime
  } = t0;
  t1 === undefined ? 1 : t1;
  const position = t2 === undefined ? 1 : t2;
  const effectiveRank = rank !== null && rank !== undefined ? rank : position;
  if (!effectiveRank) {
    return null;
  }
  const rankNumber = typeof effectiveRank === "string" ? parseInt(effectiveRank, 10) : effectiveRank;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = function getOrdinalSuffix(n) {
      const mod10 = n % 10;
      const mod100 = n % 100;
      if (mod10 === 1 && mod100 !== 11) {
        return "st";
      }
      if (mod10 === 2 && mod100 !== 12) {
        return "nd";
      }
      if (mod10 === 3 && mod100 !== 13) {
        return "rd";
      }
      return "th";
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const getOrdinalSuffix = t3;
  let dateString;
  let t4;
  if ($[1] !== decisionTime) {
    const dateTime = decisionTime ? new Date(decisionTime) : null;
    dateString = dateTime ? dateTime.toLocaleString(undefined, {
      month: "short",
      day: "numeric"
    }) : null;
    t4 = dateTime ? dateTime.toLocaleString(undefined, {
      hour: "2-digit",
      minute: "2-digit"
    }) : null;
    $[1] = decisionTime;
    $[2] = dateString;
    $[3] = t4;
  } else {
    dateString = $[2];
    t4 = $[3];
  }
  const timeString = t4;
  let accentColor;
  let bgColor;
  let rankText;
  bb0: switch (rankNumber) {
    case 1:
      {
        accentColor = "#fbbf24";
        bgColor = "rgba(251,191,36,0.1)";
        rankText = "1st";
        break bb0;
      }
    case 2:
      {
        accentColor = "#CAD5E3";
        bgColor = "rgba(202, 213, 227,0.1)";
        rankText = "2nd";
        break bb0;
      }
    case 3:
      {
        accentColor = "#CD7F32";
        bgColor = "rgba(205,127,50,0.1)";
        rankText = "3rd";
        break bb0;
      }
    default:
      {
        accentColor = "#848490";
        bgColor = "rgba(96,96,108,0.2)";
        rankText = `${rankNumber}${getOrdinalSuffix(rankNumber)}`;
      }
  }
  const t5 = `1px solid ${accentColor}40`;
  let t6;
  if ($[4] !== accentColor || $[5] !== bgColor || $[6] !== t5) {
    t6 = {
      backgroundColor: bgColor,
      color: accentColor,
      border: t5
    };
    $[4] = accentColor;
    $[5] = bgColor;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FontAwesomeIcon icon={faTrophy} className="tw-mr-1.5 tw-size-2.5" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== position) {
    t8 = position > 1 && <span className="tw-ml-1">#{position}</span>;
    $[9] = position;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== rankText || $[12] !== t8) {
    t9 = <span className="tw-px-2 tw-py-0.5 tw-text-xs tw-flex tw-items-center">{t7}{rankText}{t8}</span>;
    $[11] = rankText;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== accentColor || $[15] !== dateString || $[16] !== timeString) {
    t10 = dateString && <span className="tw-hidden md:tw-flex tw-items-center"><div style={{
        backgroundColor: `${accentColor}70`
      }} className="tw-size-[3px] tw-rounded-full" /><span className="tw-border-l tw-px-2 tw-py-0.5 tw-flex tw-items-center tw-text-xs" style={{
        borderColor: `${accentColor}40`
      }}><FontAwesomeIcon icon={faClock} className="tw-mr-1.5 tw-size-2.5" />{dateString}{timeString && <span className="tw-hidden sm:tw-inline">, {timeString}</span>}</span></span>;
    $[14] = accentColor;
    $[15] = dateString;
    $[16] = timeString;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t6 || $[20] !== t9) {
    t11 = <div className="tw-flex tw-items-center tw-rounded-md tw-font-medium tw-whitespace-nowrap" style={t6}>{t9}{t10}</div>;
    $[18] = t10;
    $[19] = t6;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};
export default WinnerDropBadge;